// constants/content-types.js
export const CONTENT_TYPES = {
    BOOKS: '本',
    MOVIES: '映画',
    MANGA: '漫画',
    EXHIBITIONS: '展覧会',
    PHILOSOPHY: '哲学'
  };